export class WindowAnalytics {
    static track(event, properties?, options?, callback?) {
        global.analytics.track(event, properties, options, callback);
    }
}
